import React, { useEffect, useState, Fragment } from 'react';
export function Countdown() {
  const [seconds, setSeconds] = useState(86172);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(value - 1, 0)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units = [['HS', Math.floor(seconds / 3600)], ['MIN', Math.floor(seconds % 3600 / 60)], ['SEG', seconds % 60]];
  return <div className="flex justify-center gap-2 font-display sm:gap-4" aria-label="Oferta termina pronto" data-id="element-345">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-346">
          {index > 0 && <span className="pt-3 text-2xl text-slate-300 sm:pt-4 sm:text-4xl" data-id="element-347">
              :
            </span>}
          <div className="min-w-[68px] rounded-xl border border-sky-100 bg-white px-3 py-2.5 text-center shadow-sm sm:min-w-[94px] sm:px-5 sm:py-3" data-id="element-348">
            <div className="text-3xl font-bold leading-none text-primary sm:text-5xl" data-id="element-349">
              {String(value).padStart(2, '0')}
            </div>
            <div className="mt-1 text-[10px] font-bold tracking-wider text-slate-400" data-id="element-350">
              {label}
            </div>
          </div>
        </Fragment>)}
    </div>;
}